import React from 'react';
import { MdDeleteOutline, MdOutlineModeEditOutline } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../infrastructure/redux/store';
import { Action, ActionGroup } from './action_group';
import { Container, Label } from './styles';

interface Props {
  label: string | null;
  onClick?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  loading?: boolean;
}

const Item: React.FC<Props> = (props) => {
  const { theme } = useSelector((state: RootState) => state.theme);

  const actions: Action[] = [
    {
      label: 'Editar',
      icone: MdOutlineModeEditOutline,
      visible: true,
      color: theme.colors.warning,
      text_color: theme.colors.textWarning,
      onClick: props.onEdit,
    },
    {
      label: 'Deletar',
      icone: MdDeleteOutline,
      visible: true,
      color: theme.colors.error,
      text_color: theme.colors.textError,
      onClick: props.onDelete,
    },
  ];

  return (
    <Container>
      <Label>{props.label}</Label>
      {props.children}
      <ActionGroup actions={actions} loading={props.loading} />
    </Container>
  );
};

export { Item };
